'use strict';

const light = {
    root: {
        padding: "24px",
    },
};

var MuiDialogContent = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiDialogContent = MuiDialogContent;
exports.light = light;
